import React, { useState, useContext } from "react";
import "../../styles.scss";
import { BsTrash } from "react-icons/bs";
import Lottie from "react-lottie";
import MainContext from "../../../../Contexts/MainContext";
import { showToast } from "../../../../Functions";
import { customConfirmAlert as confirmAlert } from '../../../../Functions';
import api from "../../../../Services/api";
import { ALL_HORARIOS } from "../../../../Services/Endpoints";
import { insertNewLog } from "../../../../Services/ApiCalls";

//Animations
const LOADING = require("../../../../Assets/animations/loading.json");
const SUCCESS = require("../../../../Assets/animations/success.json");
const ERROR = require("../../../../Assets/animations/error.json");

interface SelectedRowPrHorario {
    data: any;
}

const SelectedHorario: React.FC<SelectedRowPrHorario> = ({ data }) => {
    const {
        token,
        setOpenMoreInfo,
        sethasCloseEditModal,
        removehasCloseEditModal,
        currentLoggedUserId,
        notificationCount,
        setNotificationCount,
    } = useContext(MainContext);

    // DATA PROPS
    const { id, nome: initialNome, padrao: initialPadrao, dias: initialDias } = data;

    const [isSubmiting, setIsSubmiting] = useState(false);
    const [updateSuccess, setupdateSuccess] = useState(false);
    const [updateError, setUpdateError] = useState(false);

    const [nome, setNome] = useState(initialNome || "");
    const [padrao, setPadrao] = useState(initialPadrao || false);

    const [dias, setDias] = useState(() => {
        const defaultDays = [
            { diaDaSemana: "SEGUNDA", nomeFormatado: "Segunda-feira", ativo: false, entrada: "00:00", inicioIntervalo: "00:00", fimIntervalo: "00:00", saida: "00:00" },
            { diaDaSemana: "TERCA", nomeFormatado: "Terça-feira", ativo: false, entrada: "00:00", inicioIntervalo: "00:00", fimIntervalo: "00:00", saida: "00:00" },
            { diaDaSemana: "QUARTA", nomeFormatado: "Quarta-feira", ativo: false, entrada: "00:00", inicioIntervalo: "00:00", fimIntervalo: "00:00", saida: "00:00" },
            { diaDaSemana: "QUINTA", nomeFormatado: "Quinta-feira", ativo: false, entrada: "00:00", inicioIntervalo: "00:00", fimIntervalo: "00:00", saida: "00:00" },
            { diaDaSemana: "SEXTA", nomeFormatado: "Sexta-feira", ativo: false, entrada: "00:00", inicioIntervalo: "00:00", fimIntervalo: "00:00", saida: "00:00" },
            { diaDaSemana: "SABADO", nomeFormatado: "Sábado", ativo: false, entrada: "00:00", inicioIntervalo: "00:00", fimIntervalo: "00:00", saida: "00:00" },
            { diaDaSemana: "DOMINGO", nomeFormatado: "Domingo", ativo: false, entrada: "00:00", inicioIntervalo: "00:00", fimIntervalo: "00:00", saida: "00:00" }
        ];
        if (initialDias && Array.isArray(initialDias)) {
            return defaultDays.map(defDay => {
                const found = initialDias.find((d: any) => d.diaDaSemana === defDay.diaDaSemana);
                if (found) {
                    return {
                        ...defDay,
                        ativo: found.ativo,
                        entrada: found.entrada || "00:00",
                        inicioIntervalo: found.inicioIntervalo || "00:00",
                        fimIntervalo: found.fimIntervalo || "00:00",
                        saida: found.saida || "00:00"
                    };
                }
                return defDay;
            });
        }
        return defaultDays;
    });

    const handleToggleDay = (index: number) => {
        setDias(prev => prev.map((day, idx) => {
            if (idx === index) {
                const newAtivo = !day.ativo;
                return {
                    ...day,
                    ativo: newAtivo,
                    entrada: newAtivo ? "08:00" : "00:00",
                    inicioIntervalo: newAtivo ? "12:00" : "00:00",
                    fimIntervalo: newAtivo ? "13:30" : "00:00",
                    saida: newAtivo ? "18:00" : "00:00"
                };
            }
            return day;
        }));
    };

    const handleTimeChange = (index: number, field: string, value: string) => {
        setDias(prev => prev.map((day, idx) => {
            if (idx === index) {
                return {
                    ...day,
                    [field]: value
                };
            }
            return day;
        }));
    };

    const handleUpdate = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!nome.trim()) {
            showToast("ERROR", "Insira o nome da jornada", {});
            return;
        }

        setIsSubmiting(true);

        const updatedJornada = {
            id,
            nome,
            padrao,
            dias: dias.map(({ diaDaSemana, ativo, entrada, inicioIntervalo, fimIntervalo, saida }) => ({
                diaDaSemana,
                ativo,
                entrada,
                inicioIntervalo,
                fimIntervalo,
                saida
            }))
        };

        await api
            .put(`${ALL_HORARIOS}/${id}`, updatedJornada, {
                headers: { Authorization: token },
            })
            .then((resp) => {
                const { status } = resp;

                if (status === 200) {
                    setupdateSuccess(true);

                    insertNewLog(
                        currentLoggedUserId,
                        `Alterações feitas na jornada #${id} - ${nome}`
                    );

                    setNotificationCount(notificationCount + 1);

                    showToast(
                        "SUCCESS",
                        "Jornada atualizada com sucesso 😁",
                        {}
                    );

                    window.setTimeout(() => {
                        sethasCloseEditModal(true);
                        removehasCloseEditModal("closedModal");
                        setOpenMoreInfo(false);
                    }, 2000);
                }
            })
            .catch((err) => {
                setIsSubmiting(false);
                setUpdateError(true);
                showToast("ERROR", `${err.message}`, {});
            });
    };

    const askIfDelete = () => {
        confirmAlert({
            title: "Confirme antes de continuar",
            message: `Tem certeza que deseja excluir a jornada "${nome}"?`,
            buttons: [
                {
                    label: "Sim",
                    onClick: async () => {
                        setIsSubmiting(true);

                        await api
                            .delete(`${ALL_HORARIOS}/${id}`, {
                                headers: { Authorization: token },
                            })
                            .then((resp) => {
                                const { status } = resp;
                                if (status === 200 || status === 201) {
                                    setupdateSuccess(true);

                                    insertNewLog(
                                        currentLoggedUserId,
                                        `Jornada ${nome} excluída`
                                    );

                                    setNotificationCount(notificationCount + 1);

                                    window.setTimeout(() => {
                                        showToast(
                                            "SUCCESS",
                                            `A Jornada "${nome}" foi excluída com sucesso 😉!`,
                                            {}
                                        );

                                        sethasCloseEditModal(true);
                                        removehasCloseEditModal("closedModal");
                                        setOpenMoreInfo(false);
                                    }, 2000);
                                }
                            })
                            .catch((error) => {
                                setUpdateError(true);
                                showToast("ERROR", `${error.message}`, {});
                                window.setTimeout(() => setIsSubmiting(false), 2000);
                            });
                    },
                },
                {
                    label: "Não",
                    onClick: () => {},
                },
            ],
        });
    };

    return (
        <div className="selected__wrapper" style={{ maxWidth: '800px', width: '100%', margin: '0 auto' }}>
            {!isSubmiting ? (
                <form onSubmit={handleUpdate}>
                    <h3 className="tt-sub title-blue title-bold" style={{ marginBottom: '20px' }}>
                        Editar Jornada Semanal
                    </h3>
                    
                    <div className="form__group not__centered" style={{ width: '100%' }}>
                        <label htmlFor="nome-jornada">Nome da Jornada</label>
                        <input
                            id="nome-jornada"
                            type="text"
                            placeholder="Ex: Jornada Administrativa 44h"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            required
                            style={{ borderRadius: '8px', padding: '12px' }}
                        />
                    </div>

                    <div style={{ marginTop: '20px', marginBottom: '25px' }}>
                        <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>Configuração dos Dias</label>
                        
                        {dias.map((day, idx) => (
                            <div key={day.diaDaSemana} className={`jornada-day-row ${!day.ativo ? 'disabled' : ''}`}>
                                <div className="day-label">{day.nomeFormatado}</div>
                                <div className="day-toggle">
                                    <label className="toggle-switch">
                                        <input
                                            type="checkbox"
                                            checked={day.ativo}
                                            onChange={() => handleToggleDay(idx)}
                                        />
                                        <span className="slider"></span>
                                    </label>
                                </div>
                                <div className="day-times">
                                    <div className="time-input-group">
                                        <label>Entrada</label>
                                        <input
                                            type="time"
                                            value={day.entrada}
                                            disabled={!day.ativo}
                                            onChange={(e) => handleTimeChange(idx, "entrada", e.target.value)}
                                        />
                                    </div>
                                    <div className="time-input-group">
                                        <label>Ini. Intervalo</label>
                                        <input
                                            type="time"
                                            value={day.inicioIntervalo}
                                            disabled={!day.ativo}
                                            onChange={(e) => handleTimeChange(idx, "inicioIntervalo", e.target.value)}
                                        />
                                    </div>
                                    <div className="time-input-group">
                                        <label>Fin. Intervalo</label>
                                        <input
                                            type="time"
                                            value={day.fimIntervalo}
                                            disabled={!day.ativo}
                                            onChange={(e) => handleTimeChange(idx, "fimIntervalo", e.target.value)}
                                        />
                                    </div>
                                    <div className="time-input-group">
                                        <label>Saída</label>
                                        <input
                                            type="time"
                                            value={day.saida}
                                            disabled={!day.ativo}
                                            onChange={(e) => handleTimeChange(idx, "saida", e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="form__group not__centered form__flex" style={{ width: '100%', justifyContent: 'flex-start', gap: '10px' }}>
                        <input
                            id="padrao-checkbox"
                            type="checkbox"
                            checked={padrao}
                            onChange={(e) => setPadrao(e.target.checked)}
                            style={{ width: 'auto', flex: 'none' }}
                        />
                        <label htmlFor="padrao-checkbox" style={{ margin: 0, flex: 'none', cursor: 'pointer' }}>
                            Definir como Padrão do Sistema
                        </label>
                    </div>

                    <div className="form__group not__centered form__side-side" style={{ width: '100%', marginTop: '30px' }}>
                        <div
                            className="selected__remove bt"
                            onClick={askIfDelete}
                            style={{ margin: 0, width: '60px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px' }}
                        >
                            <BsTrash size={18} />
                        </div>
                        <button
                            type="submit"
                            className="bt"
                            style={{ margin: 0, width: '100%', maxWidth: '200px', background: '#6366f1', border: 'none', borderRadius: '8px', padding: '12px' }}
                        >
                            Salvar Alterações
                        </button>
                    </div>
                </form>
            ) : (
                <Lottie
                    options={{
                        loop: !updateSuccess ? true : false,
                        animationData:
                            !updateSuccess && !updateError
                                ? LOADING
                                : updateSuccess
                                ? SUCCESS
                                : ERROR,
                    }}
                    height={105}
                    width={105}
                />
            )}
        </div>
    );
};
export default SelectedHorario;
